module.exports = __webpack_public_path__ + "static/media/projects-text-en.857ceba2.svg";